import React, { useContext, useState, useEffect } from "react";
import { Grid, Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

// Contexts
import FacebookProfilesDashboardContext from "../../../../context/facebook_profiles/dashboard/DashboardContext";

// Components
import Info_01 from "./Info_01";
import Info_02 from "./Info_02";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginLeft: "8px",
    height: 541,
  },
  paperBox: {
    width: "100%",
  },
  // padding: "0.5rem"
}));

const BusinessInfo = () => {
  const classes = useStyles();

  const { selected_fb_details, selected_profile } = useContext(
    FacebookProfilesDashboardContext
  );

  const [bm_verification, setBmVerification] = useState("");
  const [ad_list, setAdList] = useState([]);

  useEffect(() => {
    let ad_list = [];

    selected_profile.bm_account.map((bm) => {
      if (bm.bm_account_id === selected_fb_details.business_manager) {
        setBmVerification(bm.bm_account_verification_status);
      }
    });

    selected_profile.ad_account.map((ad) => {
      if (ad.bm_account_id === selected_fb_details.id) {
        ad_list.push(ad);
      }
    });

    setAdList(ad_list);
  }, [selected_profile, selected_fb_details]);

  return (
    <Paper className={classes.paper}>
      <Grid
        container
        direction="column"
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <Grid item container className={classes.paperBox}>
          <Grid item xs={6}>
            <Info_01 bm_verification={bm_verification} ad_list={ad_list} />
          </Grid>
          <Grid item xs={6}>         
          </Grid>
        </Grid>
        <Grid item className={classes.paperBox}>
          <Info_02 ad_list={ad_list} />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default BusinessInfo;
